<template>
  <img src="/images/knee.png">
</template>

<script>
  export default {
    name: "Knee",
  }
</script>
